import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/business`;

export default {
  options(payload) {
    payload.order = "type";
    payload.sort = "asc";
    const a = Client.get(`${resource}/option`, {
      params: payload,
    });

    console.log("api res: ", a);

    return a;
  },
};
